import request from '@/config/axios'

// 房间预警 VO
export interface RoomAlertVO {
  id: string | number
  shopId: string | number
  roomId: string | number
  alertType: string
  alertLevel: string
  alertContent: string
  handleStatus: number
  handleUser: string
  handleTime: string
  handleRemark: string
  createTime: Date
}

// 获取房间预警分页
export function getRoomAlertPage(params: any) {
  return request.get({ url: '/hotel/room-alert/page', params })
}

// 处理预警
export function handleAlert(id: string | number, data: any) {
  return request.put({ url: '/hotel/room-alert/handle', data: { id, ...data } })
}

// 忽略预警
export function ignoreAlert(id: string | number) {
  return request.put({ url: '/hotel/room-alert/ignore', data: { id } })
}
